// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tdclass {\n  border: 1px solid #ccc;\n}\n\n.selectwidth {\n  width: 100%;\n}", "",{"version":3,"sources":["webpack://./src/components/opplastede_adresser/opplastede_adresser.styles.scss"],"names":[],"mappings":"AAAA;EACI,sBAAA;AACJ;;AACE;EACI,WAAA;AAEN","sourcesContent":[".tdclass{\n    border:1px solid #ccc;\n  }\n  .selectwidth {\n      width:100%\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
